export default __webpack_public_path__ + "static/404-fc1067589888a9b641cce587e6057066.svg";